import { PageId } from 'constants/pages'

export const enum PageIdWoofzLoveBl {
  DOG_SEX_LOVE = PageId.DOG_SEX_LOVE_BL,
  DOG_AGE_LOVE = PageId.DOG_AGE_LOVE_BL,
  URGE_LOVE = PageId.URGE_LOVE_BL,
  FEELINGS_LOVE = PageId.FEELINGS_LOVE_BL,
  URGE_1_LOVE = PageId.URGE_1_LOVE_BL,
  TALKING_LOVE = PageId.TALKING_LOVE_BL,
  DOG_FOLLOW_LOVE = PageId.DOG_FOLLOW_LOVE_BL,
  LICKING_LOVE = PageId.LICKING_LOVE_BL,
  URGE_2_LOVE = PageId.URGE_2_LOVE_BL,
  BEHAVIOR_LOVE = PageId.BEHAVIOR_LOVE_BL,
  FEEL_GUILTY_LOVE = PageId.FEEL_GUILTY_LOVE_BL,
  URGE_3_LOVE = PageId.URGE_3_LOVE_BL,
  DOG_REACT_LOVE = PageId.DOG_REACT_LOVE_BL,
  SATISFIED_LOVE = PageId.SATISFIED_LOVE_BL,
  BEHAVIOR_ISSUES_LOVE = PageId.BEHAVIOR_ISSUES_LOVE_BL,
  YOUR_REACTION_LOVE = PageId.YOUR_REACTION_LOVE_BL,
  URGE_4_LOVE = PageId.URGE_4_LOVE_BL,
  DOG_BREED_LOVE = PageId.DOG_BREED_LOVE_BL,
  COMMANDS_LOVE = PageId.COMMANDS_LOVE_BL,
  DOG_NAME_LOVE = PageId.DOG_NAME_LOVE_BL,
  LOVE_LOAD_SCREEN = PageId.LOVE_LOAD_SCREEN_BL,
  DOG_PROFILE_LOVE = PageId.DOG_PROFILE_LOVE_BL,
  MOTIVATION_LOVE = PageId.MOTIVATION_LOVE_BL,
  FEEL_DOG_LOVE = PageId.FEEL_DOG_LOVE_BL,
  FREQUENCY_LOVE = PageId.FREQUENCY_LOVE_BL,
  PREPARE_FLOW_LOVE = PageId.PREPARE_FLOW_LOVE_BL,
  EMAIL_LOVE = PageId.EMAIL_LOVE_BL,
  NEWSLETTER_URGE_LOVE = PageId.NEWSLETTER_URGE_LOVE_BL,
  PERSONALIZED_PLAN_LOVE = PageId.PERSONALIZED_PLAN_LOVE_BL,
  LAST_CHANCE_OFFER_LOVE = PageId.LAST_CHANCE_OFFER_LOVE_BL,
  SUBSCRIPTIONS_LOVE = PageId.SUBSCRIPTIONS_LOVE_BL,
  LAST_CHANCE_OFFER_2_LOVE = PageId.LAST_CHANCE_OFFER_2_LOVE_BL,
  CANCEL_OFFER_LOVE = PageId.CANCEL_OFFER_LOVE_BL,
  CHAT_UPSELL_LOVE = PageId.CHAT_UPSELL_LOVE_BL,
  UPSELL_LOVE = PageId.UPSELL_LOVE_BL,
  UPSELL_FEEDING_GUIDE_LOVE = PageId.UPSELL_FEEDING_GUIDE_LOVE_BL,
  UPSELL_EMOTIONAL_SUPPORT_LOVE = PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE_BL,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_LOVE = PageId.DOWNLOAD_LOVE_BL,
}
